module.exports = __webpack_public_path__ + "static/media/pickup_salmon.22e42c2d.svg";